/**
 * POPULATION-IMAGE-GROUP-ROW
 * One row of the population image groups list (avatar + populations), shared between
 * project-population-images.modal.tsx (editable) and project-message.widget.tsx (summary)
 */
import { withTranslation, WithTranslation } from "react-i18next"
import Chip from "./chip"
import Link from "./link"
import { ProjectPopulationImageGroup } from "@/redux/project.types"

interface OwnProps {
  group: ProjectPopulationImageGroup
  onRemove?: Function
}

type Props = OwnProps & WithTranslation

function PopulationImageGroupRow(props: Props) {
  const { t } = props

  return (
    <div className="flex" style={{ alignItems: "center", width: "100%" }}>
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: 8,
          backgroundColor: props.group.imageUrl ? undefined : "#ececec",
          backgroundImage: props.group.imageUrl ? `url(${props.group.imageUrl})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          flexShrink: 0
        }}
      />

      <div className="width-10" />

      <div className="flex flex-wrap flex1" style={{ columnGap: 6, rowGap: 12 }}>
        {props.group.populations.map((population) => (
          <Chip key={population.id}>{population.name}</Chip>
        ))}
      </div>

      {props.onRemove && (
        <Link isWithoutMargin onClick={() => props.onRemove?.()}>
          {t("utils_delete")}
        </Link>
      )}
    </div>
  )
}

export default withTranslation()(PopulationImageGroupRow)
